import styles from "./OwnerCell.module.css";
import {
  Avatar,
  AvatarWithTooltip,
  BetaDataTableCell as Cell,
} from "@zapier/design-system";
import { PLACEHOLDER_PROFILE_ICON } from "@zapier/utils";

interface OwnerCellProps {
  photoUrl?: string | null;
  name?: string | null;
  /** Overrides the tooltip text derived from name. */
  tooltipContent?: string | null;
  /** Optional class for the avatar container (e.g. to override alignment per table) */
  avatarClassName?: string;
}

const OwnerCell = ({
  name,
  photoUrl,
  tooltipContent,
  avatarClassName,
}: OwnerCellProps) => {
  const displayName = name?.trim() || "";
  const tooltipLabel = tooltipContent?.trim() || displayName;
  const url = photoUrl || PLACEHOLDER_PROFILE_ICON;
  const avatar = tooltipLabel ? (
    <AvatarWithTooltip
      name={tooltipLabel}
      size="small"
      url={url}
      isBlock
      placement="bottom"
    />
  ) : (
    // This case will likely never be hit, but as a fallback we'll just show a placeholder avatar and hide from screen readers.
    <Avatar name="" size="small" url={url} isBlock aria-hidden />
  );
  return (
    <Cell className={styles.ownerCell}>
      <div
        className={
          avatarClassName
            ? `${styles.avatar} ${avatarClassName}`
            : styles.avatar
        }
      >
        {avatar}
      </div>
    </Cell>
  );
};

export default OwnerCell;
